import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslationObject } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Observable, of, ReplaySubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TranslationLoaderService extends TranslateHttpLoader {
  private readonly cache = new Map<string, TranslationObject>();
  private inFlight = new Map<string, ReplaySubject<TranslationObject>>();

  constructor(_http: HttpClient) {
    const prefix = `${environment.RESOURCE_SERVER_URL}/assets/i18n/`;
    const suffix = '.json';
    super(_http, prefix, suffix);
  }

  getTranslation(lang: string): Observable<TranslationObject> {
    // Return from cache if available
    if (this.cache.has(lang)) {
      return of(this.cache.get(lang));
    }

    // Return in-flight observable if already loading
    if (this.inFlight.has(lang)) {
      return this.inFlight.get(lang)!.asObservable();
    }

    // Create a new ReplaySubject to share the result
    const subject = new ReplaySubject<TranslationObject>(1);
    this.inFlight.set(lang, subject);

    // Start the request
    super.getTranslation(lang).subscribe({
      next: (translations) => {
        this.cache.set(lang, translations);
        subject.next(translations);
        subject.complete();
      },
      error: (err) => {
        subject.error(err);
        this.inFlight.delete(lang);
      },
      complete: () => {
        this.inFlight.delete(lang);
      },
    });

    return subject.asObservable();
  }
}
